import React, { useState } from 'react';
import { ReactComponent as IndiaSvg } from '../in.svg';
import './GovtDashboard.css';

const DUMMY = {
  location: [
    { city: 'Ahmedabad', count: 42000, top: '52%', left: '22%' },
    { city: 'Vadodara', count: 31000, top: '56%', left: '26%' },
    { city: 'Gandhinagar', count: 28000, top: '50%', left: '24%' },
    { city: 'Rajkot', count: 19500, top: '54%', left: '18%' },
    { city: 'Jaipur', count: 17000, top: '40%', left: '30%' },
    { city: 'Delhi', count: 12000, top: '32%', left: '36%' },
  ],
  demography: {
    age: [
      { range: '18-25', percentage: 22 },
      { range: '26-35', percentage: 28 },
      { range: '36-45', percentage: 20 },
      { range: '46-55', percentage: 15 },
      { range: '56-65', percentage: 10 },
      { range: '65+', percentage: 5 },
    ],
    gender: [
      { type: 'Male', percentage: 52, color: '#166534' },
      { type: 'Female', percentage: 46, color: '#22C55E' },
      { type: 'Other', percentage: 2, color: '#86EFAC' },
    ],
    religion: [
      { type: 'Hindu', percentage: 80, color: '#14532D' },
      { type: 'Muslim', percentage: 10, color: '#166534' },
      { type: 'Christian', percentage: 4, color: '#22C55E' },
      { type: 'Sikh', percentage: 3, color: '#4ADE80' },
      { type: 'Other', percentage: 3, color: '#BBF7D0' },
    ],
    caste: [
      { type: 'General', percentage: 32, color: '#14532D' },
      { type: 'OBC', percentage: 38, color: '#166534' },
      { type: 'SC', percentage: 18, color: '#22C55E' },
      { type: 'ST', percentage: 12, color: '#4ADE80' },
    ],
    education: [
      { level: 'Below 10th', percentage: 18, color: '#BBF7D0' },
      { level: '10th Pass', percentage: 22, color: '#86EFAC' },
      { level: '12th Pass', percentage: 20, color: '#4ADE80' },
      { level: 'Graduate', percentage: 25, color: '#22C55E' },
      { level: 'Post-Graduate', percentage: 10, color: '#166534' },
      { level: 'Professional', percentage: 5, color: '#14532D' },
    ],
    income: [
      { bracket: '<₹1L', percentage: 20 },
      { bracket: '₹1-3L', percentage: 30 },
      { bracket: '₹3-5L', percentage: 22 },
      { bracket: '₹5-10L', percentage: 16 },
      { bracket: '₹10-25L', percentage: 8 },
      { bracket: '>₹25L', percentage: 4 },
    ],
    occupation: [
      { type: 'Agriculture', percentage: 28, color: '#14532D' },
      { type: 'Service', percentage: 22, color: '#166534' },
      { type: 'Business', percentage: 18, color: '#15803D' },
      { type: 'Labour', percentage: 15, color: '#22C55E' },
      { type: 'Student', percentage: 10, color: '#4ADE80' },
      { type: 'Homemaker', percentage: 7, color: '#86EFAC' },
    ],
  },
  categories: [
    { name: 'General', percentage: 32, voters: 128000, color: '#14532D' },
    { name: 'OBC', percentage: 28, voters: 112000, color: '#166534' },
    { name: 'EWS', percentage: 15, voters: 60000, color: '#15803D' },
    { name: 'SC', percentage: 14, voters: 56000, color: '#22C55E' },
    { name: 'ST', percentage: 8, voters: 32000, color: '#4ADE80' },
    { name: 'Minority', percentage: 3, voters: 12000, color: '#86EFAC' },
  ],
  issues: [
    { issue: 'Unemployment', intensity: 95 },
    { issue: 'Water Supply', intensity: 88 },
    { issue: 'Road Infrastructure', intensity: 85 },
    { issue: 'Healthcare Access', intensity: 82 },
    { issue: 'Education Quality', intensity: 78 },
    { issue: 'Electricity', intensity: 72 },
    { issue: 'Farm Support', intensity: 68 },
    { issue: 'Housing', intensity: 65 },
    { issue: 'Law & Order', intensity: 58 },
    { issue: 'Sanitation', intensity: 52 },
    { issue: 'Corruption', intensity: 48 },
    { issue: 'Inflation', intensity: 42 },
  ],
  sentiment: {
    overall: [
      { type: 'For', percentage: 48, color: '#166534' },
      { type: 'Neutral', percentage: 28, color: '#4ADE80' },
      { type: 'Against', percentage: 24, color: '#BBF7D0' },
    ],
    byRegion: [
      { region: 'Ahmedabad', forPct: 55, neutral: 25, against: 20 },
      { region: 'Vadodara', forPct: 50, neutral: 28, against: 22 },
      { region: 'Surat', forPct: 60, neutral: 22, against: 18 },
      { region: 'Rajkot', forPct: 42, neutral: 30, against: 28 },
      { region: 'Gandhinagar', forPct: 58, neutral: 24, against: 18 },
      { region: 'Bhavnagar', forPct: 38, neutral: 32, against: 30 },
    ],
  },
  campaigns: [
    { name: 'Vikas Yatra', positive: 62, negative: 18, neutral: 20, reach: '4.2M' },
    { name: 'Rozgar Mela', positive: 55, negative: 22, neutral: 23, reach: '3.8M' },
    { name: 'Jal Jeevan Abhiyan', positive: 70, negative: 12, neutral: 18, reach: '5.1M' },
    { name: 'Digital Gujarat', positive: 48, negative: 28, neutral: 24, reach: '2.9M' },
    { name: 'Kisan Samman Nidhi', positive: 65, negative: 15, neutral: 20, reach: '6.3M' },
    { name: 'Swachh Nagar', positive: 58, negative: 20, neutral: 22, reach: '3.4M' },
  ],
  yojnas: [
    { name: 'PM Kisan Samman Nidhi', enrolled: 185000, active: 162000, satisfaction: 78 },
    { name: 'Ayushman Bharat', enrolled: 142000, active: 118000, satisfaction: 72 },
    { name: 'PM Awas Yojana', enrolled: 98000, active: 76000, satisfaction: 65 },
    { name: 'Ujjwala Yojana', enrolled: 125000, active: 110000, satisfaction: 82 },
    { name: 'Mudra Yojana', enrolled: 68000, active: 52000, satisfaction: 60 },
    { name: 'Sukanya Samriddhi', enrolled: 45000, active: 41000, satisfaction: 85 },
    { name: 'Jan Dhan Yojana', enrolled: 210000, active: 195000, satisfaction: 75 },
    { name: 'Fasal Bima Yojana', enrolled: 72000, active: 58000, satisfaction: 55 },
  ],
  trending: [
    { topic: 'Water Crisis in Kutch', mentions: 12400, trend: 'up', sentiment: 'negative' },
    { topic: 'New Metro Line Ahmedabad', mentions: 9800, trend: 'up', sentiment: 'positive' },
    { topic: 'Farm Loan Waiver Demand', mentions: 8500, trend: 'up', sentiment: 'negative' },
    { topic: 'IT Hub in GIFT City', mentions: 7200, trend: 'stable', sentiment: 'positive' },
    { topic: 'School Merger Protests', mentions: 6100, trend: 'up', sentiment: 'negative' },
    { topic: 'Solar Energy Initiative', mentions: 5400, trend: 'stable', sentiment: 'positive' },
    { topic: 'Highway Toll Hike', mentions: 4800, trend: 'down', sentiment: 'negative' },
    { topic: 'Digital Ration Card Launch', mentions: 4200, trend: 'up', sentiment: 'positive' },
  ],
  viral: [
    { content: 'CM Speech at Gandhinagar Rally', views: '2.8M', shares: '180K', platform: 'Twitter', sentiment: 'positive' },
    { content: 'Water tanker long queue video', views: '1.9M', shares: '320K', platform: 'WhatsApp', sentiment: 'negative' },
    { content: 'New hospital inauguration', views: '1.2M', shares: '95K', platform: 'Facebook', sentiment: 'positive' },
    { content: 'Farmer protest at collectorate', views: '980K', shares: '210K', platform: 'Twitter', sentiment: 'negative' },
    { content: 'PM Yojana success story', views: '850K', shares: '78K', platform: 'Instagram', sentiment: 'positive' },
    { content: 'Road cave-in Surat clip', views: '1.5M', shares: '280K', platform: 'WhatsApp', sentiment: 'negative' },
  ],
  forecast: {
    winProbability: 62,
    turnout: 68,
    seatProjection: { win: 95, close: 22, loss: 65 },
    swingVoters: 18,
    undecided: 12,
  },
  insights: {
    focusGroups: [
      { group: 'Young Unemployed (18-30)', priority: 'Critical', action: 'Announce skill development + job mela in next 2 weeks' },
      { group: 'Farmers (Saurashtra)', priority: 'High', action: 'Water supply & MSP announcement before campaign end' },
      { group: 'Women (Urban)', priority: 'High', action: 'Highlight Ujjwala, Sukanya Samriddhi success stories' },
      { group: 'SC/ST Communities', priority: 'Medium', action: 'Direct outreach through local leaders + scheme enrollment drives' },
      { group: 'Senior Citizens', priority: 'Medium', action: 'Pension scheme awareness & healthcare camp announcements' },
    ],
    misinformation: [
      { claim: 'Govt plans to remove OBC reservations', risk: 'High', reach: '2.4M', action: 'Official rebuttal + leader statements on social media' },
      { claim: 'Water tax increase of 300%', risk: 'High', reach: '1.8M', action: 'Fact-check infographic + press conference' },
      { claim: 'Ration card cancellation for BPL', risk: 'Medium', reach: '950K', action: 'SMS campaign to BPL families with reassurance' },
      { claim: 'Private takeover of govt hospitals', risk: 'Medium', reach: '720K', action: 'Video testimonials from hospital staff' },
    ],
    correlations: [
      { finding: 'Water issue intensity ↔ Anti-incumbency', strength: 92 },
      { finding: 'Yojana enrollment ↔ Positive sentiment', strength: 85 },
      { finding: 'Unemployment rate ↔ Youth voter turnout drop', strength: 78 },
      { finding: 'Road quality ↔ Rural voter satisfaction', strength: 74 },
      { finding: 'Social media reach ↔ Youth vote swing', strength: 68 },
    ],
    campaignInsights: [
      'Jal Jeevan Abhiyan has the highest positive sentiment — amplify in rallies',
      'Digital Gujarat campaign underperforming in rural areas — shift to offline media',
      'Rozgar Mela negative sentiment rising — address job quality concerns',
      'Kisan Samman Nidhi most popular but lowest awareness in tribal belts',
    ],
    yojnaInsights: [
      'Fasal Bima has lowest satisfaction (55%) — simplify claim process',
      'Ayushman Bharat enrollment high but usage low — awareness camps needed',
      'Ujjwala Yojana highest satisfaction — use beneficiaries as campaign ambassadors',
      'PM Awas progress slow in Saurashtra — fast-track 12,000 pending houses',
    ],
    speechTopics: [
      { topic: 'Water & Infrastructure', relevance: 95, audience: 'Rural + Semi-urban' },
      { topic: 'Employment & Skill Dev', relevance: 92, audience: 'Youth 18-30' },
      { topic: 'Women Empowerment Schemes', relevance: 88, audience: 'Women voters' },
      { topic: 'Farm MSP & Support', relevance: 85, audience: 'Agricultural belt' },
      { topic: 'Digital India Progress', relevance: 72, audience: 'Urban educated' },
      { topic: 'Healthcare Expansion', relevance: 78, audience: 'Senior citizens' },
    ],
  },
};

const FIRST_NAMES_M = ['Ramesh','Suresh','Mahesh','Rajesh','Dinesh','Bharat','Vijay','Ashok','Ratan','Gopal','Kishore','Pravin','Jayesh','Hardik','Kailash','Shankar','Mohan','Govind','Baldev','Hasmukh','Devang','Chirag','Parth','Darshan','Nilesh','Hitesh','Jignesh','Brijesh','Kamlesh','Alpesh'];
const FIRST_NAMES_F = ['Rekha','Sunita','Geeta','Kamla','Savita','Meena','Pushpa','Laxmi','Radha','Saroj','Anita','Hetal','Jyoti','Nirmala','Usha','Bhavna','Darshana','Kiran','Smita','Manisha'];
const LAST_NAMES = ['Patel','Shah','Mehta','Desai','Joshi','Bhatt','Trivedi','Parmar','Chauhan','Solanki','Thakur','Yadav','Chaudhary','Raval','Pandya','Dave','Thakor','Makwana','Vaghela','Gohil'];
const VILLAGES = ['Chandkheda','Bopal','Dholka','Sanand','Bavla','Viramgam','Dhandhuka','Mandal','Petlad','Borsad','Anklav','Umreth','Nadiad','Mahemdabad','Kapadvanj','Modasa','Bayad','Bhiloda','Meghraj','Idar','Khedbrahma','Vijapur','Mehsana','Unjha','Sidhpur','Palanpur','Deesa','Danta','Ambaji','Dhari'];
const BOOTHS = Array.from({ length: 50 }, (_, i) => `Booth-${101 + i}`);

const generateVoters = (count) => {
  const castes = ['General', 'OBC', 'SC', 'ST', 'EWS'];
  const religions = ['Hindu', 'Muslim', 'Christian', 'Sikh', 'Other'];
  const educations = ['Below 10th', '10th Pass', '12th Pass', 'Graduate', 'Post-Graduate'];
  const sentiments = ['For', 'Against', 'Neutral'];
  const voters = [];
  for (let i = 1; i <= count; i++) {
    const isMale = Math.random() > 0.46;
    const fn = isMale
      ? FIRST_NAMES_M[Math.floor(Math.random() * FIRST_NAMES_M.length)]
      : FIRST_NAMES_F[Math.floor(Math.random() * FIRST_NAMES_F.length)];
    const ln = LAST_NAMES[Math.floor(Math.random() * LAST_NAMES.length)];
    const age = 18 + Math.floor(Math.random() * 62);
    const incomeBase = Math.floor(8 + Math.random() * 92);
    const income = incomeBase * 1000;
    voters.push({
      id: i,
      name: `${fn} ${ln}`,
      age,
      gender: isMale ? 'Male' : 'Female',
      caste: castes[Math.floor(Math.random() * castes.length)],
      religion: religions[Math.floor(Math.random() * (Math.random() > 0.2 ? 1 : religions.length))],
      education: educations[Math.floor(Math.random() * educations.length)],
      income: `₹${income.toLocaleString('en-IN')}`,
      village: VILLAGES[Math.floor(Math.random() * VILLAGES.length)],
      booth: BOOTHS[Math.floor(Math.random() * BOOTHS.length)],
      sentiment: sentiments[Math.floor(Math.random() * 3)],
      yojnas: Math.floor(Math.random() * 4),
      lastVoted: Math.random() > 0.15 ? 'Yes' : 'No',
      issues: [DUMMY.issues[Math.floor(Math.random() * 6)].issue, DUMMY.issues[Math.floor(Math.random() * 12)].issue].filter((v, j, a) => a.indexOf(v) === j),
    });
  }
  return voters;
};

const VOTERS = generateVoters(100);

const getHeatColor = (intensity) => {
  if (intensity >= 80) return '#166534';
  if (intensity >= 60) return '#22C55E';
  if (intensity >= 40) return '#86EFAC';
  if (intensity >= 20) return '#BBF7D0';
  return '#DCFCE7';
};
const getHeatText = (intensity) => (intensity >= 60 ? '#fff' : '#1E293B');

const DonutChart = ({ data, size = 130, strokeWidth = 24 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  let cum = 0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {data.map((item, i) => {
        const seg = (item.percentage / 100) * circumference;
        const offset = cum;
        cum += seg;
        return (
          <circle key={i} cx={size / 2} cy={size / 2} r={radius} fill="none"
            stroke={item.color} strokeWidth={strokeWidth}
            strokeDasharray={`${seg} ${circumference - seg}`}
            strokeDashoffset={-offset}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{ transition: 'stroke-dasharray 0.5s ease' }}
          />
        );
      })}
    </svg>
  );
};

const IndiaMap = ({ locations }) => {
  const maxCount = Math.max(...locations.map(l => l.count));
  return (
    <div className="gd-map-wrapper">
      <div className="gd-svg-frame">
        <IndiaSvg className="gd-india-base" />
        {locations.map(loc => {
          const scale = loc.count / maxCount;
          return (
            <div key={loc.city} className="gd-hotspot"
              style={{ top: loc.top, left: loc.left, width: `${14 + scale * 36}px`, height: `${14 + scale * 36}px` }}
            />
          );
        })}
      </div>
      <div className="gd-map-legend">
        <div className="gd-map-legend-title">Voter Density</div>
        <div className="gd-map-legend-scale">
          <span className="gd-dot hot" /> High
          <span className="gd-dot med" /> Medium
          <span className="gd-dot low" /> Low
        </div>
      </div>
    </div>
  );
};

const GovtDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedVoter, setSelectedVoter] = useState(VOTERS[0]);

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'sentiment', label: 'Sentiment & Campaigns' },
    { id: 'trends', label: 'Trends & Forecast' },
    { id: 'voter', label: 'Individual Voter' },
    { id: 'insights', label: 'Insights' },
  ];

  const renderOverview = () => (
    <div className="gd-sections">
      {/* Stats */}
      <div className="gd-row gd-stats-row">
        {[
          { icon: '🗳️', val: '4,00,000', label: 'Total Voters' },
          { icon: '📊', val: '68%', label: 'Expected Turnout' },
          { icon: '🏘️', val: '182', label: 'Booths Covered' },
          { icon: '📈', val: '62%', label: 'Win Probability' },
        ].map(s => (
          <div key={s.label} className="glass-card gd-stat-card">
            <span className="gd-stat-icon">{s.icon}</span>
            <span className="gd-stat-val">{s.val}</span>
            <span className="gd-stat-lbl">{s.label}</span>
          </div>
        ))}
      </div>

      {/* Map + Age */}
      <div className="gd-row gd-map-row">
        <div className="glass-card gd-map-card">
          <h3>📍 Geography — Voter Distribution</h3>
          <IndiaMap locations={DUMMY.location} />
        </div>
        <div className="glass-card gd-age-card">
          <h3>👤 Age Distribution</h3>
          <div className="gd-age-bars">
            {DUMMY.demography.age.map(a => (
              <div key={a.range} className="gd-age-col">
                <div className="gd-age-track">
                  <div className="gd-age-fill" style={{ height: `${a.percentage * 2.5}%` }}><span>{a.percentage}%</span></div>
                </div>
                <span className="gd-age-label">{a.range}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Donuts — Gender, Religion, Caste, Occupation */}
      <div className="gd-row">
        <div className="glass-card full-width">
          <h3>🧑‍🤝‍🧑 Demography Breakdown</h3>
          <div className="gd-donut-row">
            {[
              { title: 'Gender', data: DUMMY.demography.gender, key: 'type' },
              { title: 'Religion', data: DUMMY.demography.religion, key: 'type' },
              { title: 'Caste', data: DUMMY.demography.caste, key: 'type' },
              { title: 'Occupation', data: DUMMY.demography.occupation, key: 'type' },
            ].map(g => (
              <div key={g.title} className="gd-donut-group">
                <h4>{g.title}</h4>
                <DonutChart data={g.data} />
                <div className="gd-donut-legend">
                  {g.data.map(d => (
                    <div key={d[g.key]} className="gd-legend-item">
                      <span className="gd-legend-dot" style={{ background: d.color }} />{d[g.key]} — {d.percentage}%
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Education + Income */}
      <div className="gd-row gd-two-col">
        <div className="glass-card">
          <h3>🎓 Education Level</h3>
          <div className="gd-bar-list">
            {DUMMY.demography.education.map(e => (
              <div key={e.level} className="gd-bar-row">
                <span className="gd-bar-name">{e.level}</span>
                <div className="gd-bar-track"><div className="gd-bar-fill" style={{ width: `${e.percentage}%`, background: e.color }}>{e.percentage}%</div></div>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card">
          <h3>💰 Income Distribution</h3>
          <div className="gd-income-bars">
            {DUMMY.demography.income.map(inc => (
              <div key={inc.bracket} className="gd-income-col">
                <div className="gd-income-track">
                  <div className="gd-income-fill" style={{ height: `${inc.percentage * 2.8}%` }}><span>{inc.percentage}%</span></div>
                </div>
                <span className="gd-income-label">{inc.bracket}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );

  const renderSentiment = () => (
    <div className="gd-sections">
      {/* Overall Sentiment */}
      <div className="gd-row gd-two-col">
        <div className="glass-card">
          <h3>🎯 Overall Sentiment</h3>
          <div className="gd-sentiment-visual">
            <DonutChart data={DUMMY.sentiment.overall} size={160} strokeWidth={30} />
            <div className="gd-donut-legend">
              {DUMMY.sentiment.overall.map(s => (
                <div key={s.type} className="gd-legend-item">
                  <span className="gd-legend-dot" style={{ background: s.color }} />{s.type} — {s.percentage}%
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="glass-card">
          <h3>🗺️ Sentiment by Region</h3>
          <div className="gd-region-list">
            {DUMMY.sentiment.byRegion.map(r => (
              <div key={r.region} className="gd-region-row">
                <span className="gd-region-name">{r.region}</span>
                <div className="gd-stacked-bar">
                  <div className="gd-stack-seg for" style={{ width: `${r.forPct}%` }}>{r.forPct}%</div>
                  <div className="gd-stack-seg neutral" style={{ width: `${r.neutral}%` }}>{r.neutral}%</div>
                  <div className="gd-stack-seg against" style={{ width: `${r.against}%` }}>{r.against}%</div>
                </div>
              </div>
            ))}
            <div className="gd-stack-legend">
              <span><span className="gd-legend-dot" style={{ background: '#166534' }} /> For</span>
              <span><span className="gd-legend-dot" style={{ background: '#4ADE80' }} /> Neutral</span>
              <span><span className="gd-legend-dot" style={{ background: '#BBF7D0' }} /> Against</span>
            </div>
          </div>
        </div>
      </div>

      {/* Issues Heatmap */}
      <div className="gd-row">
        <div className="glass-card full-width">
          <h3>🔥 Issues Heatmap</h3>
          <div className="gd-heatmap-legend"><span>Low</span><div className="gd-legend-grad" /><span>Critical</span></div>
          <div className="gd-issues-grid">
            {DUMMY.issues.map(item => (
              <div key={item.issue} className="gd-issue-cell" style={{ background: getHeatColor(item.intensity), color: getHeatText(item.intensity) }}>
                <span className="gd-issue-name">{item.issue}</span>
                <span className="gd-issue-val">{item.intensity}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Campaign Responses */}
      <div className="gd-row">
        <div className="glass-card full-width">
          <h3>📣 Campaign Responses</h3>
          <div className="gd-campaign-list">
            {DUMMY.campaigns.map(c => (
              <div key={c.name} className="gd-campaign-row">
                <div className="gd-campaign-header">
                  <span className="gd-campaign-name">{c.name}</span>
                  <span className="gd-campaign-reach">Reach: {c.reach}</span>
                </div>
                <div className="gd-stacked-bar">
                  <div className="gd-stack-seg for" style={{ width: `${c.positive}%` }}>+{c.positive}%</div>
                  <div className="gd-stack-seg neutral" style={{ width: `${c.neutral}%` }}>{c.neutral}%</div>
                  <div className="gd-stack-seg against" style={{ width: `${c.negative}%` }}>-{c.negative}%</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Yojna Usage */}
      <div className="gd-row">
        <div className="glass-card full-width">
          <h3>📑 Yojna Usage & Satisfaction</h3>
          <div className="gd-yojna-grid">
            {DUMMY.yojnas.map(y => (
              <div key={y.name} className="gd-yojna-card">
                <div className="gd-yojna-name">{y.name}</div>
                <div className="gd-yojna-stats">
                  <div className="gd-yojna-stat"><span className="gd-yojna-num">{(y.enrolled / 1000).toFixed(0)}K</span><span className="gd-yojna-lbl">Enrolled</span></div>
                  <div className="gd-yojna-stat"><span className="gd-yojna-num">{(y.active / 1000).toFixed(0)}K</span><span className="gd-yojna-lbl">Active</span></div>
                  <div className="gd-yojna-stat"><span className="gd-yojna-num">{y.satisfaction}%</span><span className="gd-yojna-lbl">Satisfaction</span></div>
                </div>
                <div className="gd-yojna-bar-track"><div className="gd-yojna-bar-fill" style={{ width: `${y.satisfaction}%`, background: getHeatColor(y.satisfaction) }} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderTrends = () => (
    <div className="gd-sections">
      {/* Win probability + Forecast */}
      <div className="gd-row gd-stats-row">
        <div className="glass-card gd-stat-card">
          <span className="gd-stat-icon">🏆</span>
          <span className="gd-stat-val">{DUMMY.forecast.winProbability}%</span>
          <span className="gd-stat-lbl">Win Probability</span>
        </div>
        <div className="glass-card gd-stat-card">
          <span className="gd-stat-icon">🗳️</span>
          <span className="gd-stat-val">{DUMMY.forecast.turnout}%</span>
          <span className="gd-stat-lbl">Turnout Forecast</span>
        </div>
        <div className="glass-card gd-stat-card">
          <span className="gd-stat-icon">🔄</span>
          <span className="gd-stat-val">{DUMMY.forecast.swingVoters}%</span>
          <span className="gd-stat-lbl">Swing Voters</span>
        </div>
        <div className="glass-card gd-stat-card">
          <span className="gd-stat-icon">❓</span>
          <span className="gd-stat-val">{DUMMY.forecast.undecided}%</span>
          <span className="gd-stat-lbl">Undecided</span>
        </div>
      </div>

      {/* Seat Projection */}
      <div className="gd-row">
        <div className="glass-card full-width">
          <h3>🪑 Seat Projection</h3>
          <div className="gd-seat-bar">
            <div className="gd-seat-seg win" style={{ flex: DUMMY.forecast.seatProjection.win }}>
              <span>{DUMMY.forecast.seatProjection.win}</span>
              <small>Win</small>
            </div>
            <div className="gd-seat-seg close" style={{ flex: DUMMY.forecast.seatProjection.close }}>
              <span>{DUMMY.forecast.seatProjection.close}</span>
              <small>Close</small>
            </div>
            <div className="gd-seat-seg loss" style={{ flex: DUMMY.forecast.seatProjection.loss }}>
              <span>{DUMMY.forecast.seatProjection.loss}</span>
              <small>Loss</small>
            </div>
          </div>
        </div>
      </div>

      {/* Trending Topics */}
      <div className="gd-row gd-two-col">
        <div className="glass-card">
          <h3>🔥 Trending Topics</h3>
          <div className="gd-trending-list">
            {DUMMY.trending.map((t, i) => (
              <div key={i} className="gd-trending-row">
                <span className="gd-trending-rank">#{i + 1}</span>
                <div className="gd-trending-info">
                  <span className="gd-trending-topic">{t.topic}</span>
                  <span className="gd-trending-meta">{t.mentions.toLocaleString()} mentions · {t.trend === 'up' ? '📈' : t.trend === 'down' ? '📉' : '➡️'}</span>
                </div>
                <span className={`gd-trending-tag ${t.sentiment}`}>{t.sentiment}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card">
          <h3>📱 Viral Content</h3>
          <div className="gd-viral-list">
            {DUMMY.viral.map((v, i) => (
              <div key={i} className="gd-viral-row">
                <div className="gd-viral-info">
                  <span className="gd-viral-title">{v.content}</span>
                  <span className="gd-viral-meta">{v.platform} · {v.views} views · {v.shares} shares</span>
                </div>
                <span className={`gd-trending-tag ${v.sentiment}`}>{v.sentiment}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderVoter = () => (
    <div className="gd-voter-container">
      <div className="gd-voter-sidebar glass-card">
        <h3>Voters</h3>
        <div className="gd-voter-list">
          {VOTERS.map(v => (
            <div key={v.id} className={`gd-voter-item ${selectedVoter.id === v.id ? 'active' : ''}`} onClick={() => setSelectedVoter(v)}>
              <div className="gd-voter-avatar">{v.name.charAt(0)}</div>
              <div className="gd-voter-item-info">
                <span className="gd-voter-name">{v.name}</span>
                <span className="gd-voter-village">{v.village}</span>
              </div>
              <span className={`gd-voter-sentiment-dot ${v.sentiment.toLowerCase()}`} />
            </div>
          ))}
        </div>
      </div>
      <div className="gd-voter-detail glass-card">
        <div className="gd-voter-header">
          <div className="gd-voter-avatar-lg">{selectedVoter.name.charAt(0)}</div>
          <div className="gd-voter-header-info">
            <h2>{selectedVoter.name}</h2>
            <span className="gd-voter-sub">{selectedVoter.village} · {selectedVoter.booth}</span>
          </div>
          <span className={`gd-voter-sentiment-badge ${selectedVoter.sentiment.toLowerCase()}`}>{selectedVoter.sentiment}</span>
        </div>
        <div className="gd-voter-grid">
          <div className="gd-info-card">
            <h4>Personal Info</h4>
            {[
              ['Age', selectedVoter.age],
              ['Gender', selectedVoter.gender],
              ['Caste', selectedVoter.caste],
              ['Religion', selectedVoter.religion],
              ['Education', selectedVoter.education],
              ['Income', selectedVoter.income],
            ].map(([l, v]) => (
              <div key={l} className="gd-info-row"><span className="gd-info-label">{l}</span><span className="gd-info-value">{v}</span></div>
            ))}
          </div>
          <div className="gd-info-card">
            <h4>Voting Profile</h4>
            {[
              ['Booth', selectedVoter.booth],
              ['Sentiment', selectedVoter.sentiment],
              ['Last Voted', selectedVoter.lastVoted],
              ['Yojnas Enrolled', selectedVoter.yojnas],
            ].map(([l, v]) => (
              <div key={l} className="gd-info-row"><span className="gd-info-label">{l}</span><span className="gd-info-value">{v}</span></div>
            ))}
          </div>
          <div className="gd-info-card gd-span-2">
            <h4>Key Issues</h4>
            <div className="gd-tag-list">
              {selectedVoter.issues.map((issue, i) => <span key={i} className="gd-tag">{issue}</span>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderInsights = () => (
    <div className="gd-sections">
      {/* Focus Groups */}
      <div className="gd-row">
        <div className="glass-card full-width">
          <h3>🎯 Who to Focus On</h3>
          <div className="gd-focus-list">
            {DUMMY.insights.focusGroups.map((f, i) => (
              <div key={i} className="gd-focus-row">
                <div className="gd-focus-header">
                  <span className="gd-focus-group">{f.group}</span>
                  <span className={`gd-priority-badge ${f.priority.toLowerCase()}`}>{f.priority}</span>
                </div>
                <span className="gd-focus-action">→ {f.action}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Misinformation */}
      <div className="gd-row">
        <div className="glass-card full-width">
          <h3>⚠️ Misinformation Tracker</h3>
          <div className="gd-misinfo-list">
            {DUMMY.insights.misinformation.map((m, i) => (
              <div key={i} className="gd-misinfo-row">
                <div className="gd-misinfo-header">
                  <span className="gd-misinfo-claim">"{m.claim}"</span>
                  <span className={`gd-priority-badge ${m.risk.toLowerCase()}`}>{m.risk} Risk</span>
                </div>
                <div className="gd-misinfo-meta">Reach: {m.reach}</div>
                <span className="gd-misinfo-action">✅ {m.action}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Correlations */}
      <div className="gd-row gd-two-col">
        <div className="glass-card">
          <h3>🔗 Key Correlations</h3>
          <div className="gd-corr-list">
            {DUMMY.insights.correlations.map((c, i) => (
              <div key={i} className="gd-corr-row">
                <span className="gd-corr-finding">{c.finding}</span>
                <div className="gd-corr-bar-track"><div className="gd-corr-bar-fill" style={{ width: `${c.strength}%`, background: getHeatColor(c.strength) }} /></div>
                <span className="gd-corr-val">{c.strength}%</span>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card">
          <h3>🗣️ Speech Builder — Top Topics</h3>
          <div className="gd-speech-list">
            {DUMMY.insights.speechTopics.map((s, i) => (
              <div key={i} className="gd-speech-row">
                <div className="gd-speech-info">
                  <span className="gd-speech-topic">{s.topic}</span>
                  <span className="gd-speech-audience">{s.audience}</span>
                </div>
                <div className="gd-speech-relevance">
                  <div className="gd-speech-bar-track"><div className="gd-speech-bar-fill" style={{ width: `${s.relevance}%` }} /></div>
                  <span>{s.relevance}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Campaign + Yojna Insights */}
      <div className="gd-row gd-two-col">
        <div className="glass-card">
          <h3>📣 Campaign Insights</h3>
          <div className="gd-insight-bullets">
            {DUMMY.insights.campaignInsights.map((c, i) => (
              <div key={i} className="gd-insight-bullet">
                <span className="gd-bullet-icon">💡</span>
                <span>{c}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card">
          <h3>📑 Yojna Insights</h3>
          <div className="gd-insight-bullets">
            {DUMMY.insights.yojnaInsights.map((y, i) => (
              <div key={i} className="gd-insight-bullet">
                <span className="gd-bullet-icon">💡</span>
                <span>{y}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderTab = () => {
    switch (activeTab) {
      case 'overview': return renderOverview();
      case 'sentiment': return renderSentiment();
      case 'trends': return renderTrends();
      case 'voter': return renderVoter();
      case 'insights': return renderInsights();
      default: return renderOverview();
    }
  };

  return (
    <div className="govt-dashboard">
      <header className="gd-header">
        <h1>Government Dashboard — Gujarat</h1>
        <div className="gd-header-meta"><span className="gd-live-dot" /><span className="gd-last-upd">Live Analytics</span></div>
      </header>
      <nav className="gd-tabs">
        {tabs.map(t => (
          <button key={t.id} className={`gd-tab-btn ${activeTab === t.id ? 'active' : ''}`} onClick={() => setActiveTab(t.id)}>{t.label}</button>
        ))}
      </nav>
      <main className="gd-main">
        {renderTab()}
      </main>
    </div>
  );
};

export default GovtDashboard;
